import React, { useState, useEffect } from "react";

import { useTranslation } from "../../i18n/TranslationProvider";

import { getProviderList } from "../../api/messageRequests";
import { getUserProviderType, getAssignedProvider, updateAssignedProvider } from "../../api/TBIRequests";

import Select from "react-select";

const AssignmentButton = ({ userId, patientId, clinicLocation }) => {
    const { t } = useTranslation();
    const [providerList, setProviderList] = useState([]);
    const [userProviderType, setUserProviderType] = useState(null);
    const [assignedProvider, setAssignedProvider] = useState(null);
    const [assignedVirtualTherapist, setAssignedVirtualTherapist] = useState(null);

    useEffect(() => {
        const fetchProviderList = async () => {
            try {
                const res = await getProviderList();
                const providers = res.data
                const formattedProviders = providers.map(provider => ({
                    value: provider.provider_id,
                    label: provider.full_name
                }));
                setProviderList(formattedProviders);
            } catch (err) {
                console.error('Error fetching provider list', err)
            }
        }

        const fetchUserProviderType = async () => {
            try {
                const res = await getUserProviderType({ userId });
                setUserProviderType(res.data.type);
            } catch (err) {
                console.error('Error fetching user provider type', err)
            }
        }
        fetchProviderList();
        fetchUserProviderType();
    }, []);

    useEffect(() => {
        const fetchAssignedProvider = async () => {
            try {
                const res = await getAssignedProvider({ patientId });
                if (res.data && res.data.assigned_provider_id) {
                    const matchingProvider = providerList.find(
                        (provider) => provider.value === res.data.assigned_provider_id
                    )
                    setAssignedProvider(matchingProvider);
                }
            } catch (err) {
                console.error('Error fetching assigned provider', err)
            }
        }

        const fetchAssignedVirtualTherapist = async () => {
            try {
                const res = await getAssignedProvider({ patientId, type: 'virtualTherapist' });
                if (res.data && res.data.assigned_provider_id) {
                    const matchingProvider = providerList.find(
                        (provider) => provider.value === res.data.assigned_provider_id
                    )
                    setAssignedVirtualTherapist(matchingProvider);
                }
            } catch (err) {
                console.error('Error fetching assigned virtual therapist', err)
            }
        }

        fetchAssignedProvider();
        if (clinicLocation === 'Virtual') {
            fetchAssignedVirtualTherapist();
        }
    }, [patientId, providerList, clinicLocation])

    const handleChange = async (selectedOption) => {
        setAssignedProvider(selectedOption);
        try {
            await updateAssignedProvider({ patientId }, { assignedProviderId: selectedOption.value });
        } catch (err) {
            console.error("Error updating assigned provider:", err);
        }
    };

    const handleChangeVT = async (selectedOption) => {
        setAssignedVirtualTherapist(selectedOption);
        try {
            await updateAssignedProvider({ patientId }, { assignedProviderId: selectedOption.value, type: 'virtualTherapist' });
        } catch (err) {
            console.error("Error updating assigned virtual therapist:", err);
        }
    };

    const isDropdownDisabled = !(
        userProviderType === 'operations' || userProviderType === 'administrativeSupport'
    )

    return (
        <>
            <h6>{t("dashboard.assignmentButton.header")}</h6>
            <Select
                options={providerList}
                placeholder={t("dashboard.assignmentButton.placeholder")}
                value={assignedProvider}
                onChange={handleChange}
                isDisabled={isDropdownDisabled}
            />
            {isDropdownDisabled &&
                <p className='required mt-2'>
                    {t("dashboard.assignmentButton.permissionsNotice")}
                </p>
            }
            {clinicLocation === 'Virtual' && (
                <>
                    <h6 className="mt-3">{t("dashboard.virtualTherapistButton.header")}</h6>
                    <Select
                        options={providerList}
                        placeholder={t("dashboard.virtualTherapistButton.placeholder")}
                        value={assignedVirtualTherapist}
                        onChange={handleChangeVT}
                        isDisabled={isDropdownDisabled}
                    />
                    {isDropdownDisabled &&
                        <p className='required mt-2'>
                            {t("dashboard.virtualTherapistButton.permissionsNotice")}
                        </p>
                    }
                </>
            )}
        </>
    )
}
export default AssignmentButton;